import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Carousel, { Modal, ModalGateway } from "react-images"
import { Col, Row, Container } from "react-bootstrap"

const useGallery = (filter = "") => {
  const data = useStaticQuery(graphql`
    query CommunityImages {
      allFile(
        filter: {
          sourceInstanceName: { eq: "community" }
          ext: { in: [".jpg", ".png", ".jpeg", ".webp"] }
        }
        sort: { order: ASC, fields: name }
      ) {
        nodes {
          id
          name
          publicURL
          sourceInstanceName
          relativeDirectory
          childImageSharp {
            fixed(width: 160, height: 160) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  `)

  let results = data.allFile.nodes.map((node, i) => ({
    ...node.childImageSharp,
    id: node.id,
    name: node.name,
    relativeDirectory: node.relativeDirectory,
    source: node.publicURL,
  }))

  results = results.filter(
    ({ relativeDirectory }) => filter === relativeDirectory
  )

  return results
}

const Slideshow = ({ images, startIndex = 0, modalIsOpen }) => {
  const [_modalIsOpen, setModalOpen] = useState(modalIsOpen)
  const [currentIndex, updateIndex] = useState(startIndex)
  const toggleModal = () => setModalOpen(() => !_modalIsOpen)

  return (
    <>
      <ModalGateway>
        {_modalIsOpen && (
          <Modal onClose={() => toggleModal()}>
            <Carousel currentIndex={currentIndex} views={images} />
          </Modal>
        )}
      </ModalGateway>
      {!_modalIsOpen && (
        <Container className={"slideshow my-5"} fluid={true}>
          <Row>
            {images.map((image, i) => (
              <Col
                key={image.id}
                onClick={e => {
                  updateIndex(i)
                  toggleModal()
                }}
              >
                <Img
                  className={"rounded"}
                  loading={"lazy"}
                  fixed={image.fixed}
                  alt={image.name}
                />
              </Col>
            ))}
          </Row>
        </Container>
      )}
    </>
  )
}

export default props => {
  let { images } = props

  let photos = useGallery(images)

  return <Slideshow key={`carousel-${images}`} images={photos} />
}
